import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-title',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleComponent {
  readonly titleKey = input('TITLE.HEADING.LINE1');
  /** Rendered inside the h1 as a second line, keeping a single h1 per page. */
  readonly taglineKey = input<string | null>('TITLE.HEADING.LINE2');
  readonly subtitleKey = input('TITLE.SUBTITLE.TEXT');
}
